module.exports = __webpack_public_path__ + "assets/img/Type E (87).02a8eae2.jpg";